
const prefixA = '{create-master-template}';

export const INIT = `${prefixA} INIT`;
export const CREATE = `${prefixA} CREATE`;
export const TYPE_NAME = `${prefixA} TYPE_NAME`;

const prefixB = 'master-template-list';
export const GET_LIST = `${prefixB} GET_LIST`;
export const UPDATE_TEMPLATE_PROPS = `${prefixB} UPDATE_TEMPLATE_PROPS`;
export const GET_ASSOCIATED_TEMPLATES = `${prefixB} GET_ASSOCIATED_TEMPLATES`;
export const DELETE_TEMPLATE = `${prefixB} DELETE TEMPLATE`;
export const RENAME_TEMPLATE = `${prefixB} RENAME_TEMPLATE`;



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template-list/__storeFiles__/constants.js